import { ComponentType, useEffect } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from 'store';

import { loadFeatureFlags } from 'hooks/useFeatureFlags';
import { firebaseAuth } from 'lib/firebase/firebase.client';
import { initializeSettingsSyncWithAuth } from 'modules/settings-sync/init';
import { usageStoreActions } from 'modules/usage/store/actions';
import { teamMiddlewareOnUserUpdate } from 'store/team/middleware';

export default function withLegacyBaseApp<T extends object>(ReactComponent: ComponentType<T>): ComponentType<T> {
  const WithLegacyBaseAppComponent = (props: T) => {
    useEffect(() => {
      let authChangedCleanup: (() => void) | null = null;
      let settingsSyncCleanup: (() => void) | null = null;

      authChangedCleanup = firebaseAuth.onAuthStateChanged(async user => {
        const setAudioServerUser = await import('lib/speechify/adaptors/audioServer');
        if (user?.uid) {
          loadFeatureFlags({ uid: user.uid, email: user.email || 'anonymous@example.com' });
          usageStoreActions.fetchUserUsageData();
          setAudioServerUser.setAudioServerUser(user);
          teamMiddlewareOnUserUpdate(store.dispatch);

          // settings sync
          settingsSyncCleanup = initializeSettingsSyncWithAuth();
        }
      });

      return () => {
        authChangedCleanup?.();
        settingsSyncCleanup?.();
      };
    }, []);

    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ReactComponent {...props} />
        </PersistGate>
      </Provider>
    );
  };

  return WithLegacyBaseAppComponent;
}
